module.exports = __webpack_public_path__ + "images/rdr2_rgba(0,0,0,0.7).613b9b40a39d49184e13101bed9703d5.jpg";